const shader = `
#define PRECISION 0.0001

uniform bool gpuPicker;
uniform bool circularPoints;

varying vec3 vColor;
varying float vAlpha;
varying vec2 vUv;
varying vec4 vGPUColor;

void main(void) {
    vec4 point_color = vec4(vColor, vAlpha);
    vec4 color = point_color;

    // Discard if not visible
    if (color.a < PRECISION) {
        discard;
    }

    // Circular points
    if (circularPoints) {
        float u = 2.0 * gl_PointCoord.x - 1.0;
        float v = 2.0 * gl_PointCoord.y - 1.0;
        float cc = u*u + v*v;
        if(cc > 1.0){
            discard;
        }
    }

    vec4 final;
    if (gpuPicker) {
        final = vGPUColor;
    } else {
        final = color;
    }

    gl_FragColor = final;
}
`;

export default shader;